/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import { Card } from 'bundles/program-loggedin-shared/components/Card';

const styles = {
  title: () => css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

// Alongside our custom props, allow HTML Div attributes (e.g. data-* for e2e test tagging)
type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  children: React.ReactNode;
};

export const SummaryCard = ({ title, children, ...attributes }: CardProps) => {
  return (
    <Card {...attributes}>
      {title && (
        // eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2
        <Typography css={styles.title} variant="h2semibold">
          {title}
        </Typography>
      )}
      {children}
    </Card>
  );
};

export default SummaryCard;
